import { Box, Button } from '@mui/material'
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { candidateAttemptEvents } from '../../../../../../axios/api/candidate'
import CustomDialog from '../../../../../../components/dialog'
import CustomTextField from '../../../../../../components/textfield'
import { getUserDetails } from '../../../../../../utils/utils'
import OverlayLoading from '../../../../../../components/overlay-loading'

const RemarkTimelineModal = memo(
  ({
    open,
    handleClose,
    positionTime,
    attemptId,
    handleRefreshAttemptEvent = () => {},
    programmingChallengeId = null
  }) => {
    const [remark, setRemark] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)

    const currentUser = useMemo(() => {
      return getUserDetails()
    }, [])

    const handleAddRemark = useCallback(async () => {
      if (!remark?.trim()) {
        setError('Remark is required')
        return
      }
      const payload = {
        attemptId: attemptId,
        event: 'candidateRemark',
        eventTimestamp: positionTime,
        eventDetails: {
          remark: remark,
          ...(programmingChallengeId && { programmingChallengeId }),
          userName: currentUser?.name
        }
      }
      setLoading(true)
      await candidateAttemptEvents(payload)
      setLoading(false)
      handleRefreshAttemptEvent()
      handleClose()
    }, [
      positionTime,
      remark,
      programmingChallengeId,
      attemptId,
      handleClose,
      handleRefreshAttemptEvent,
      currentUser?.name
    ])
    useEffect(() => {
      if (!open) {
        setRemark('')
        setError('')
      }
    }, [open])
    return (
      <>
        {loading && <OverlayLoading />}
        <CustomDialog
          open={open}
          title="Add Remark"
          handleClose={() => handleClose()}
        >
          <Box sx={{ gap: '16px', display: 'flex', flexDirection: 'column' }}>
            <CustomTextField
              required
              multiline
              fullWidth
              minRows={3}
              needOnBlur={true}
              onChange={({ target: { value } }) => {
                setRemark(value)
                setError(value?.trim() ? '' : 'Remark is required')
              }}
              error={Boolean(error)}
              {...(error ? { helperText: error } : {})}
              value={remark}
              placeholder={'Add Remark here....'}
            />
            <Button
              variant="contained"
              onClick={handleAddRemark}
              disabled={loading}
            >
              Add
            </Button>
          </Box>
        </CustomDialog>
      </>
    )
  }
)
export default RemarkTimelineModal
